import { decodeToken } from '../hooks/decodeToken'

const { role } = decodeToken()
const defaultRole = () => role

export default defaultRole
